// extracted by mini-css-extract-plugin
module.exports = {"root":"br_bk"};